import React from "react";
import PropTypes from 'prop-types';

StyleableSection.propTypes = {
  className: PropTypes.object,
  section: PropTypes.object,
  children: PropTypes.array
};

export default function StyleableSection({section, className, children}) {

  let style = {};

  function setStyleProperty(property, value) {
    if(value || value === 0) {
      style[property] = value;
    }
  }

  if (section) {
    if (section.margin) {
      setStyleProperty('marginLeft', section.margin.marginLeft);
      setStyleProperty('marginRight', section.margin.marginRight);
      setStyleProperty('marginTop', section.margin.marginTop);
      setStyleProperty('marginBottom', section.margin.marginBottom);
    }
    if (section.padding) {
      setStyleProperty('paddingLeft', section.padding.paddingLeft);
      setStyleProperty('paddingRight', section.padding.paddingRight);
      setStyleProperty('paddingTop', section.padding.paddingTop);
      setStyleProperty('paddingBottom', section.padding.paddingBottom);
    }
    if (section.background) {
      setStyleProperty('backgroundColor', section.background.backgroundColor);
      setStyleProperty('backgroundImage', section.background.backgroundImage ? `url("${section.background.backgroundImage}")` : null);
      setStyleProperty('backgroundPosition', section.background.backgroundPosition);
      setStyleProperty('backgroundRepeat', section.background.backgroundRepeat);
      setStyleProperty('backgroundOrigin', section.background.backgroundOrigin);
      setStyleProperty('backgroundAttachment', section.background.backgroundAttachment);
      setStyleProperty('backgroundSize', section.background.backgroundSize);
    }
    if (section.border) {
      setStyleProperty('borderLeftWidth', section.border.borderLeft.width);
      setStyleProperty('borderLeftStyle', section.border.borderLeft.style);
      setStyleProperty('borderLeftColor', section.border.borderLeft.color);

      setStyleProperty('borderRightWidth', section.border.borderRight.width);
      setStyleProperty('borderRightStyle', section.border.borderRight.style);
      setStyleProperty('borderRightColor', section.border.borderRight.color);

      setStyleProperty('borderTopWidth', section.border.borderTop.width);
      setStyleProperty('borderTopStyle', section.border.borderTop.style);
      setStyleProperty('borderTopColor', section.border.borderTop.color);

      setStyleProperty('borderBottomWidth', section.border.borderBottom.width);
      setStyleProperty('borderBottomStyle', section.border.borderBottom.style);
      setStyleProperty('borderBottomColor', section.border.borderBottom.color);

      setStyleProperty('borderTopLeftRadius', section.border.borderTopLeftRadius.radius);
      setStyleProperty('borderTopRightRadius', section.border.borderTopRightRadius.radius);
      setStyleProperty('borderBottomLeftRadius', section.border.borderBottomLeftRadius.radius);
      setStyleProperty('borderBottomRightRadius', section.border.borderBottomRightRadius.radius);
    }
  }

  return (
    <div className={className} style={style}>
      {children}
    </div>
  );

}
